import type { Beast, BeastState } from '../../../models/Beast';
import type { Surroundings } from '../../../models/Surroundings';
import type { IBeastState } from './IBeastState';
import { BEAST } from '../../../models/constants';
import { BeastExploringState } from './BeastExploringState';
import { BeastEatingState } from './BeastEatingState';

export class BeastSleepingState implements IBeastState {
    static readonly stateName = 'Sleeping';

    get allowInterrupt(): boolean {
        return false;
    }

    canEnter(beast: Beast, _surroundings: Surroundings): boolean {
        return beast.sleepTicks > 0;
    }

    tick(beast: Beast, surroundings: Surroundings): BeastState {
        beast.sleepTicks--;
        if (beast.sleepTicks <= 0) return BeastExploringState.stateName;
        if (beast.health < BEAST.HUNGER_THRESHOLD && surroundings.availableFood > 0) return BeastEatingState.stateName;
        return BeastSleepingState.stateName;
    }
}
